import { useState, useEffect } from "react";
import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { Input, Button } from "antd";
import { MessageOutlined, CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const TextNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();

  // Local state prevents focus loss on every keystroke
  const [message, setMessage] = useState(data.message || "");
  useEffect(() => { setMessage(data.message || ""); }, [data.message]);

  const commit = (value) => data.onChange?.({ ...data, message: value });

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#10b981" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color="#10b981" />
      <Handle type="target" position={Position.Left} style={{ background: "#10b981" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <MessageOutlined style={{ color: "#10b981", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Text Message</strong>
        <Button type="text" size="small" icon={<CopyOutlined />} onClick={() => data.onDuplicate?.()} style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />} onClick={() => deleteElements({ nodes: [{ id }] })} style={{ color: "#9ca3af" }} />
      </div>

      <div className="nodrag" onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <NodeNameInput data={data} />
        <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>
          Message <span style={{ color: "#9ca3af" }}>{message.length}/1098</span>
        </label>
        <Input.TextArea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onBlur={(e) => commit(e.target.value)}
          rows={3}
          maxLength={1098}
          placeholder="Enter message text..."
          style={{ fontSize: 12 }}
        />
        {data.flowTriggerType === "newCompanyAdmin" ? (
          <div style={{ marginTop: 6, background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 5, padding: "5px 8px", fontSize: 10, color: "#166534", lineHeight: 1.7 }}>
            <strong>Registration vars:</strong>{" "}
            <code>{"{{reg_firstname}}"}</code> <code>{"{{reg_email}}"}</code> <code>{"{{reg_phone}}"}</code>
          </div>
        ) : (
          <div style={{ marginTop: 4, fontSize: 10, color: "#9ca3af" }}>
            Use <code>{"{{firstname}}"}</code> <code>{"{{email}}"}</code> <code>{"{{phone}}"}</code> etc.
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Right} style={{ background: "#10b981" }} />
    </div>
  );
};

export default TextNode;
